module.exports = __webpack_public_path__ + "img/android.e0330218.png";